import { render, staticRenderFns } from "./DashboardPage.vue?vue&type=template&id=e8ecac0a"
import script from "./DashboardPage.vue?vue&type=script&lang=js"
export * from "./DashboardPage.vue?vue&type=script&lang=js"
import style0 from "./DashboardPage.vue?vue&type=style&index=0&id=e8ecac0a&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8ecac0a')) {
      api.createRecord('e8ecac0a', component.options)
    } else {
      api.reload('e8ecac0a', component.options)
    }
    module.hot.accept("./DashboardPage.vue?vue&type=template&id=e8ecac0a", function () {
      api.rerender('e8ecac0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/attendances/dashboard/DashboardPage.vue"
export default component.exports